import { createSlotRecipe } from './runtime.js';

const iconButtonConfig = {"name":"iconButton","slots":["root"],"defaultVariants":{"variant":"tertiary"},"variantMap":{"variant":["impact","primary","secondary","tertiary"]}}

export const iconButton = /* @__PURE__ */ createSlotRecipe(iconButtonConfig)